import classNames from 'classnames';
import FalconCardHeader from 'components/common/FalconCardHeader';
import PropTypes from 'prop-types';
import React from 'react';
import { Badge, Card, Table, Row, Col } from 'react-bootstrap';
import SurveyPieChart from './SurveyPieChart';

// Colores HEX equivalentes a Bootstrap
const COLORS = [
  '#0d6efd', // primary
  '#198754', // success
  '#0dcaf0', // info
  '#ffc107', // warning
  '#dc3545', // danger
  '#6c757d', // secondary
  '#343a40' // dark
];

const QuestionStats = ({ question, isLast }) => {
  const { question_text, total_answers, options } = question;
  console.log('Question:', question);
  const optionList = Object.values(options).sort((a, b) => b.count - a.count);

  return (
    <Card className={classNames('mb-2  shadow-sm', { 'border-0': isLast })}>
      <FalconCardHeader
        title={question_text}
        light={false}
        titleTag="h5"
        className="pb-2"
      />
      <div className="px-3 pb-2">
        <Badge
          bg="primary"
          className="fs-10 px-2 py-1"
          style={{ fontWeight: 400 }}
        >
          {total_answers} respuestas
        </Badge>
      </div>
      <Card.Body className="pt-0">
        <Row className="g-3 flex-column flex-md-row align-items-stretch">
          <Col
            xs={12}
            md={4}
            className="d-flex justify-content-center align-items-center mb-3 mb-md-0"
            style={{ minWidth: 0 }}
          >
            <div
              style={{
                width: '100%',
                minHeight: 320, // Aumenta este valor si tienes muchas opciones
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
              }}
            >
              <SurveyPieChart optionList={optionList} colors={COLORS} />
            </div>
          </Col>
          <Col xs={12} md={8}>
            <div style={{ overflowX: 'auto' }}>
              <Table
                bordered
                hover
                responsive
                size="sm"
                className="mb-0 align-middle"
                style={{
                  borderWidth: 1,
                  borderColor: '#343a40',
                  borderStyle: 'solid',
                  fontSize: '0.7rem'
                }}
              >
                <thead className="table-light">
                  <tr>
                    <th
                      className="text-center align-middle"
                      style={{
                        borderWidth: 1,
                        borderColor: '#343a40',
                        fontSize: '0.65rem',
                        fontWeight: 500,
                        padding: '0.25rem 0.5rem',
                        width: '40px'
                      }}
                    ></th>
                    <th
                      className="align-middle"
                      style={{
                        borderWidth: 1,
                        borderColor: '#343a40',
                        fontSize: '0.65rem',
                        fontWeight: 500,
                        padding: '0.25rem 0.5rem'
                      }}
                    >
                      Opción
                    </th>
                    <th
                      className="text-end align-middle"
                      style={{
                        borderWidth: 1,
                        borderColor: '#343a40',
                        fontSize: '0.65rem',
                        fontWeight: 500,
                        padding: '0.25rem 0.5rem'
                      }}
                    >
                      Respuestas
                    </th>

                    <th
                      className="text-center align-middle"
                      style={{
                        borderWidth: 1,
                        borderColor: '#343a40',
                        fontSize: '0.65rem',
                        fontWeight: 500,
                        padding: '0.25rem 0.5rem'
                      }}
                    >
                      %
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {optionList.map((option, idx) => (
                    <tr key={idx}>
                      <td
                        className="text-center align-middle"
                        style={{
                          padding: '0.25rem 0.5rem',
                          borderWidth: 1,
                          borderColor: '#343a40'
                        }}
                      >
                        <span
                          className="badge bg-primary"
                          style={{ fontSize: '0.7rem', minWidth: '20px' }}
                        >
                          #{idx + 1}
                        </span>
                      </td>
                      <td
                        style={{
                          padding: '0.25rem 0.5rem',
                          fontSize: '0.7rem'
                        }}
                      >
                        {option.option_text}
                      </td>
                      <td
                        className="text-end align-middle"
                        style={{
                          borderWidth: 1,
                          borderColor: '#343a40',
                          padding: '0.25rem 0.5rem',
                          fontSize: '0.7rem'
                        }}
                      >
                        {option.count}
                      </td>

                      <td
                        className="text-center align-middle fw-bold"
                        style={{
                          borderWidth: 1,
                          borderColor: '#343a40',
                          padding: '0.25rem 0.5rem',
                          fontSize: '0.7rem'
                        }}
                      >
                        {option.percentage}%
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </div>
          </Col>
        </Row>
      </Card.Body>
    </Card>
  );
};

QuestionStats.propTypes = {
  question: PropTypes.shape({
    question_text: PropTypes.string.isRequired,
    total_answers: PropTypes.number.isRequired,
    options: PropTypes.objectOf(
      PropTypes.shape({
        option_text: PropTypes.string.isRequired,
        count: PropTypes.number.isRequired,
        percentage: PropTypes.string.isRequired
      })
    ).isRequired
  }),
  isLast: PropTypes.bool
};

const SurveyResponsesCount = ({ option_stats }) => {
  if (!option_stats || Object.keys(option_stats).length === 0) {
    return (
      <Card>
        <FalconCardHeader
          title="Resultados de Encuesta"
          light={false}
          titleTag="h5"
          className="pb-0"
        />
        <Card.Body className="p-4 text-center text-muted pt-2">
          No hay datos disponibles para mostrar.
        </Card.Body>
      </Card>
    );
  }

  const questions = Object.values(option_stats);

  return (
    <>
      <Row className="g-3">
        <Col xs={12}>
          {questions.map((question, index) => (
            <QuestionStats
              question={question}
              isLast={index === questions.length - 1}
              key={index}
            />
          ))}
        </Col>
      </Row>
    </>
  );
};

SurveyResponsesCount.propTypes = {
  option_stats: PropTypes.object.isRequired
};

export default SurveyResponsesCount;
